import { adaptRentingApprovalCalculationsPayload } from "../../infrastructure/adapters/adaptRentingDetails";
import { reviewRequestDetails } from "../../infrastructure/repository/request-repository";

export default async function reviewRentingDetailsRequest({
  companyId,
  requestId,
  rentingData,
  callback,
}: {
  companyId: string;
  requestId: string;
  rentingData: any;
  callback(e: any): void;
}): Promise<void> {
  const adaptedPayload = adaptRentingApprovalCalculationsPayload(rentingData);
  const { data } = await reviewRequestDetails({
    companyId,
    category: "renting-benefit",
    requestId,
    payload: adaptedPayload,
  });
  callback(data);
}
